import { useActiveSchoolId } from '../../hooks/useActiveSchoolId';
import { useUserStore } from '../../stores/UserStore';
import { Switcher } from './Switcher';

type Props = {
	title?: string;
	isMobile?: boolean;
};

export const SchoolSwitch = ({ title, isMobile }: Props) => {
	const schools = useUserStore(state => state.schools);

	const { activeSchoolId, setActiveSchoolId } = useActiveSchoolId();

	const activeSchool = schools.find(school => school.id === activeSchoolId);

	if (!activeSchool || schools.length < 2) {
		return null;
	}

	const items = schools.map(school => ({
		id: school.id,
		label: school.name,
		isActive: school.id === activeSchoolId,
	}));

	return <Switcher items={items} select={setActiveSchoolId} title={title} isMobile={isMobile} />;
};
